interface ScenariosBlockProps {
  content: {
    title?: string;
    subtitle?: string;
    tags?: string[];
  };
}

export function ScenariosBlock({ content }: ScenariosBlockProps) {
  if (!content.tags?.length) return null;

  return (
    <section className="mx-auto max-w-[1200px] px-6 py-20">
      <div className="text-center">
        {content.title && (
          <h2 className="font-serif text-2xl md:text-3xl text-foreground mb-3">
            {content.title}
          </h2>
        )}
        {content.subtitle && (
          <p className="font-sans text-sm text-muted-foreground mb-10">
            {content.subtitle}
          </p>
        )}
        <div className="flex flex-wrap justify-center gap-3">
          {content.tags.map((tag, i) => (
            <span
              key={i}
              className="font-sans text-xs uppercase tracking-[0.12em] border border-border px-5 py-2.5 text-foreground/70 bg-background"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
